// extracted by mini-css-extract-plugin
export default {"spinner-overlay":"Spinner_spinner-overlay__5OHpF","spinner":"Spinner_spinner__bHRJa","spin":"Spinner_spin__H4FQm"};